import ComputePipeline from "../../lib/services/compute/computepipeline";

export default class Blob2RowPipeline extends ComputePipeline {
  private device: GPUDevice;
  private layout: GPUBindGroupLayout;
  private info_buffer: GPUBuffer | null = null;
  private basic_buffer: GPUBuffer | null = null;

  constructor(key: string, shader: GPUShaderModule, device: GPUDevice, threads: number) {
    super(key,threads);
    this.device = device;
    
    const V = GPUShaderStage.COMPUTE;
    const stex_r = { access: "read-only" as const, format: "rgba8unorm" as const };

    this.layout = device.createBindGroupLayout({
      entries: [
        { binding: 0, visibility: V, buffer: { type: "read-only-storage" } },
        { binding: 1, visibility: V, storageTexture: stex_r },
        { binding: 2, visibility: V, buffer: { type: "storage" } },
      ],
    });

    this.pipeline = device.createComputePipeline({
      layout: device.createPipelineLayout({ bindGroupLayouts: [this.layout] }),
      compute: { module: shader, entryPoint: key },
    });
  }

  build(info_buffer: GPUBuffer, basic_buffer: GPUBuffer): void {
    this.info_buffer = info_buffer;
    this.basic_buffer = basic_buffer;
  }

  rebuild(mask_tex_view: GPUTextureView): void {
    this.bindgroup = this.device.createBindGroup({
      layout: this.layout,
      entries: [
        { binding: 0, resource: { buffer: this.info_buffer! } },
        { binding: 1, resource: mask_tex_view },
        { binding: 2, resource: { buffer: this.basic_buffer! } },
      ],
    });
  }
}